const translationsAr = {
    _lang: "English",
    LANGUAGE_NAME: "عربي",
    USERNAME: "اسم المستخدم",
    PASSWORD: "كلمة المرور",
    LOGIN: "تسجيل دخول",
    SYSTEM_NAME: "نظام التقدم",
    STUDENTS: "طلاب",
    COPY_RIGHT: "جميع الحقوق محفوظة",
    CITC: "انطلاق لتقنية الاتصالات والمعلومات",
    REFUND_POLICY: "سياسة الاسترداد ",
    PRIVACY_POLICY: "سياسة الخصوصيه",
    PRIVACY_POLICY_TITLE: "سياسة خصوصية وتأمين البيانات",
    TERMS_RULES: "الشروط والأحكام",
    MANS: "جامعة المنصورة",
    CONTACT_US: "اتصل بنا",
    CHANGE_LANGUAGE: "تغيير اللغة",
    ACCOUNT: "الحساب",
    NOTIFICATIONS: "الإشعارات",
    SCOPE: "تغيير المجال",
    ACADEMIC_YEAR_SEMESTER: "تغيير الفصل الدراسي والعام الأكاديمي",
    PROFILE: "الصفحة الشخصية",
    LOGOUT: "تسجيل الخروج",
    FORGOT_PASSWORD: "نسيت كلمة المرور؟",
    UPDATE_MAIL_TO_ACTIVATE: "إعادة إرسال البريد الإلكترونى لتفعيل الحساب ",
    ADMISSION_GATE: " بوابة التقديم الإلكتروني",
    CLOSE: "غلق",
    SUCCESSED_LOGIN: "تم الدخول بنجاح",
    USERNAME_MAX: "اسم المستخدم يجب ألا يتعدى 70 حرفاً",
    USERNAME_REQUIRED: "من فضلك أدخل اسم المستخدم",
    PASSWORD_MAX: "كلمة المرور يجب ألا تتعدى 20 حرفاً",
    PASSWORD_REQUIRED: "من فضلك أدخل كلمة المرور",
    ACADEMIC_SEMESTER: "الفصل الدراسي",
    ACADEMIC_YEAR: "العام الأكاديمي",
    BACK: "عودة",
    SAVE: "حفظ",
    CANCEL: "إلغاء",
    CREDENTIAL_ERROR: "اسم المستخدم أو كلمة المرور غير صحيحة",
    NOT_FOUND_SERVER_ERROR: "حدث خطأ، برجاء الاتصال بمشرفي النظام",
    AR_NAME: "الاسم بالعربية",
    EN_NAME: "الاسم بالإنجليزية",
    NAME: "الاسم",
    STUDENT_NAME: "اسم الطالب",
    SIGNATURE: "التوقيع",
    STUDENT_SIGNATURE: "توقيع الطالب ",
    IS_ACTIVE: "فعال",
    ADD_NEW: "إضافة",
    EDIT: "تعديل",
    DELETE: "حذف",
    YES: "نعم",
    NO: "لا",
    PRINT: "طباعة",
    PRINT_APPLICATION: "طباعة نموذج التقديم",
    PRINT_DESIRE_FORM: "طباعة استمارة الرغبات",
    DESIRE_FORM: "استمارة الرغبات",
    COUNT: "العدد لكل صفحة",
    SUCCESS: "تم الحفظ بنجاح",
    REQUIRED_FIELD: "هذا الحقل مطلوباً",
    BIRTHDATE_MAX: "تاريخ الميلاد لا يجب ان يتواجد تاريخ اليوم",
    ACTIVE: "فعال",
    NOT_ACTIVE: "غير فعال",
    ACTIVATION: "تفعيل",
    NO_DATA: "لا توجد بيانات",
    ARABIC_FIELD: "أدخل حروف عربية فقط",
    ENGLISH_FIELD: "أدخل حروف انجليزية فقط",
    ACTIONS: "التحكم",
    MAX_FIELD: "عدد حروف هذا الحقل يجب أن لا تتعدى ",
    MIN_FIELD: "عدد حروف هذا الحقل يجب أن لا يقل عن ",
    CONFIRM: "تأكيد",
    CONFIRMATION_MESSAGE: "رسالة تأكيد",
    WARNING: "تحذير",
    DELETE_CONFIRMATION: "هل تريد تنفيذ عملية الحذف؟",
    PREVENT_NUMBERS_IN_FIRST: "يجب أن لا يبدأ هذا الحقل بأرقام",
    ACTIVATE: "تفعيل",
    DEACTIVATE: "الغاء التفعيل",
    NEED_HELP: "هل تريد مساعدة ؟",
    STATUS: "الحالة",
    YEAR: "السنة",
    RESET: "تفريغ الحقول",
    SEARCH: "بحث",
    TOTAL: "المجموع",
    OPENED: "مفتوح",
    CLOSED: "مغلق",
    ROWS_PER_PAGE_TEXT: "الصفوف لكل صفحة:",
    PAGE_TEXT: "من",
    USERNAME_VALIDATION:
        "يتكون اسم المستخدم من حروف وأرقام إنجليزية فقط ولا يقل عن 3 أحرف",
    NID_VALIDATION: "الرقم القومي غير صحيح",
    PASSPORT_VALIDATION:
        "رقم جواز السفر غير صحيح يجب أن يحتوي على حروف انجليزية وأرقام فقط",
    EMAIL_VALIDATION:
        "يجب أن يكون البريد الإلكتروني مثل هذا النموذج user@domain.xxx وألا يزيد اسم الحساب عن 64 حرف",
    PREVENT_SPECIAL_CHARACTER_FIELD: "يجب أن لا يحتوي هذا الحقل على علامات خاصة",
    PASSWORD_VALIDATION:
        "أدخل كلمة مرور معقدة على الأقل حرف انجليزي كبير ورقم ورمز",
    CONFIRM_PASSWORD_VALIDATION: "كلمة المرور غير متطابقة",
    EMAIL: "البريد الإلكتروني ( برجاء التأكد من إدخال بريد فعال وصحيح لتفعيل الحساب من خلاله ومتابعةالطلبات المقدمه )",
    CONFIRM_PASSWORD: "تأكيد كلمة المرور",
    NID: "الرقم القومي",
    RE_ENTER_NID: "أعادة إدخال الرقم القومي للحساب الغير المفعل ",
    RE_ENTER_EMAIL: "البريد الإلكتروني لتفيل الحساب ",
    PASSPORT: "جواز السفر",
    CREAT_ACOUNT: "إنشاء حساب",
    CREAT_ACOUNT_IN: "إنشاء حساب ب",
    LOGIN_INSTEAD: "تسجيل الدخول بدلاً من ذلك",
    REGISTER: "إنشاء حساب جديد",
    ALL_NEWS: "كل الأخبار",
    USERNAME_EMAIL: "اسم المستخدم / البريد الإلكتروني",
    GO_TO_LOGIN_CONFIRMATION:
        "هل تريد التوجه لصفحة تسجيل الدخول بدلاَ من إنشاء حساب؟",
    DOWNLOAD_CONSENT_FILE: "تحميل الإقرار",
    DOWNLOAD_CONSENT_NOTES: "(من فضلك يجب تحميل الإقرار وإعادة رفعه لإكمال البيانات )",
    PRIVACY_POLICY_POINTS: {
        POINT1: " - جميع البيانات التي يتم تسجيلها على النظام هي ملك للجهة صاحبة هذه البيانات.",
        POINT2: "- لا يتم الاطلاع على هذه البيانات من قبل مهندسي الشركة إلا للضرورة القصوى ولغرض الدعم الفني وبالاتفاق مع الجهة صاحبة البيانات شفوياً أو كتابياً",
        POINT3: "- لا يتم إعطاء أي بيان من بيانات النظام لأي فرد او جهة فرعية تنتمي للجهة صاحبة البيانات او لأي جهة أخرى إلا بموافقة كتابية من الجهة صاحبة البيانات",
        POINT4: "- يمكن استخدام البيانات المسجلة على النظام بهدف عمل إحصائيات يستفاد منها فى قياس اداء النظام وكفاءة استخدامه من قبل مستخدميه",
        POINT5: "- يتم تأمين جميع البيانات الخاصة بالنظام من خلال تأمين الحاسب الخادم الذي يستضيف البيانات ومن خلال تأمين انتقال البيانات بين جهاز المستخدم والحاسب الخادم وكذلك تأمين واجهة النظام التي يستخدمها المستخدم\n",
        POINT6: "- كل مستخدم للنظام مسئول مسئولية كاملة عن كلمة المرور الخاصة به وعليه اتخاذ كافة الاحتياطات الممكنة حتى لا يستطيع أى شخص آخر الحصول عليها",
    },
    REFUND_POLICY_POINTS: {
        POINT1: "-  جميع المدفوعات التي تتم عبر الموقع نهائية وغير قابلة للاسترداد، إلا في حال حدوث خطأ تقني أو إداري موثق أثناء عملية الدفع.",
        POINT2: "- في هذه الحالة، يُمكن للمستخدم طلب استرداد المبلغ مع تقديم ما يثبت الخطأ",
        POINT3: "- وإذا كان سيتم استرداد المبلغ المدفوع تخضع جميع طلبات الاسترداد للمراجعة والموافقة من قبل الإدارة المختصة.",
    },
    TERMS_RULES_POINTS: {
        POINT1: "- يقدم الموقع خدمة دفع المصروفات الدراسية إلكترونيًا للطلاب نيابة عن المؤسسات التعليمية المتعاقدة. يتم إرسال المدفوعات مباشرة إلى حسابات المؤسسات التعليمية وفقًا للبيانات المقدمة من المستخدم.",
        POINT2: "- يتحمل المستخدم مسؤولية دقة وصحة البيانات التي يقدمها أثناء عملية الدفع.",
        POINT3: "- قد تفرض رسوم خدمة إضافية على كل عملية دفع إلكتروني. يتم توضيح هذه الرسوم للمستخدم قبل إتمام العملية.",
        POINT4: "- يستخدم الموقع بروتوكولات حماية متقدمة لتأمين البيانات المالية والشخصية. ومع ذلك، فإن المستخدم يقر بمسؤوليته في الحفاظ على سرية معلومات الدفع الخاصة به وعدم مشاركتها مع الغير",
        POINT5: "- لا يتحمل الموقع أي مسؤولية عن أي تأخير أو فشل في إتمام العملية بسبب مشاكل تقنية خارجة عن إرادتنا أو استخدام المستخدم للموقع بطريقة مخالفة للقانون أو الشروط المنصوص عليها.",
        POINT6: "- يحتفظ الموقع بحقه في تعديل هذه الشروط والأحكام في أي وقت دون إشعار مسبق. ويعد استمرار استخدام الموقع بعد التعديل موافقة ضمنية على الشروط الجديدة.",
    },

    ADMISSION_DATA: {
        APPLICATION_ID: "رقم المسلسل ",
        APPLICATION_DATE: "تاريخ الطلب",
        APPID: "رقم الطلب",
        NEXT: "التالي",
        BACK: "السابق",
        SAVE: "إرسال",
        DRAFT: "حفظ كمسودة(معلق لحين إستكمال الارسال)",
        CANCEL: "إلغاء",
        GO_TO_APP_LIST_CONFIRMATION:
            "هل تريد التوجه لصفحة طلبات التقديم الخاصة بك؟",
        TERMS:
            "اقر ان كافة المعلومات الموضحة في بيان التقديم صحيحة ومطابقة تماما للمستندات الشخصية الخاصة بي وأتحمل مسؤولية اي خطأ بها دون اي مسؤولية علي النظام او المراجعين",
        UPLOAD_IMG: "تغيير الملف",
        IMAGE_ATTACHED: "الملف المرفق",
        APP_STATUS: "حالة الطلب",
        APP_STATUSES: ["مسودة(معلق لحين إستكمال الارسال)", "تحت المراجعة", "مقبول", "مرفوض", "مطلوب إكماله",
            "مرشح للقبول", "مرشح للرفض", "تحت المراجعة", "تم النقل لشؤون الطلاب", "مقبول بكلية اخرى", "قيد الإنتظار"],
        STEP1: {
            NAME: "البيانات الشخصية",
            AR_FULLNAME: "الاسم كامل باللغة العربية",
            EN_FULLNAME: "الاسم كامل باللغة الإنجليزية",
            ID: "رقم الهوية",
            IDTYPE: "",
            ID_IMAGE: "صورة الهوية",
            NATIONALID: "رقم قومي",
            PASSPORT: "جواز سفر",
            IDHINT: "الرقم القومي أو جواز السفر",
            TYPE: "النوع",
            FEMALE: "انثي",
            MALE: "ذكر",
            MUSLIM: " مسلم ",
            CHRISTIAN: " مسيحى ",
            RELIGION: " الديانه ",
            PHONE: "رقم الموبايل",
            TELEPHONE: "رقم التليفون",
            EMAIL: "البريد الإلكتروني",
            BIRTHDATE: "تاريخ الميلاد",
            IMAGE: "الصورة الشخصية",
            COUNTRY: "الدولة",
            STATE: "المحافظة/الولاية",
            CITY: "المدينة",
            NATIIONALITY: "بلد الجنسية",
            ADDRESS: "العنوان",
            BIRTHPLACE: "محل الميلاد",
            CONTACTS: "ييانات الاتصال",
            PERSONAL_DATA: "البيانات الشخصية",
            BIRTH_CERT: "صورة شهادة الميلاد",
            GUARDIAN_CARD: "صورة بطاقة ولي الأمر",
            MILITARY_FORM: "نموذج التجنيد(إختيارى)"
        },
        STEP2: {
            NAME: "المؤهل",
            CERTIFICATION: "نوع الشهادة",
            MAJOR: "التخصص",
            YEAR: "عام الحصول على المؤهل",
            SEATNO: "رقم الجلوس لطلاب الثانويه العامه المصريه  فقط ",
            PULL_SECONDARY_DATA: "اسحب بياناتى ",
            SUM: "المجموع",
            PERCENTAGE: "النسبه",
            EQUIVALENT_CERT_TYPE: "نوع شهادة المعادلة",
            CERT_FROM_COUNTRY: "من دولة",
            CERTIFICATE_IMAGE: "صورة المؤهل",
            CERTIFICATE_FILE: "ملف المؤهل ",
            CERTIFICATE_IMAGE2: "صورة المؤهل 2",
            CERTIFICATE_IMAGE3: "صورة المؤهل 3",
            RECEIPT_IMAGE: "صورة ايصال الدفع",
            STU_RESIDENCE_IMAGE: "صورة إثبات إقامة الطالب",
            LEGAL_GUARDIAN_RESIDENCE_IMAGE: "صورة إثبات إقامة ولى الامر ",
            CONSENT_FILE: "ملف الاقرار ",
            CERTIFICATE_NAME: "اسم الشهادة",
            TOTAL_MIN: "ينبغي أن يزيد مجموع /نسبة الشهادة عن  0",
            TOTAL_MAX: "ينبغي ألا يزيد مجموع الشهادة عن 999999 وألا تزيدالنسبه عن 200% ",
            TOTAL_PERC_GS_MAX: "ينبغي أن تكون النسبه بين 0 و  100% ",
        },
        STEP3: {
            NAME: "بيانات التقدم",
            ACDYEAR: "العام الدراسي",
            SEMESTER: "الفصل الدراسي",
            FACULTY: "الكلية",
            DESIRE: "الرغبه ",
            BRANCH: "الفرع",
            MESSAGE:
                "لإكمال طلبك يرجي إختيار الكلية والموافقة علي الأحكام والشروط المعرفة أدناه",
            TERMS: "الشروط والأحكام",
            ADMISSION_TERMS: "شروط التقديم و القبول",
            CHECK: "أوافق علي",
            SAVE: "إرسال",
            CANCEL: "إلغاء",
            NEXT_CONFIRMATION: "سيتم حفظ بيانات الطلب كمسودة(معلق لحين إستكمال الارسال) حتى تتمكن من دفع رسوم الطلب ويتم إرسال الطلب بمجرد الدفع لذا يرجى مراجعة بيانات الطلب أولاً. موافق؟",
            NEXT_INITIAL_CONFIRMATION: "سيتم حفظ بيانات الطلب كمسودة(تقديم مبدئي) حتى تتمكن من دفع رسوم الطلب ويتم إرسال الطلب بمجرد الدفع لذا يرجى مراجعة بيانات الطلب أولاً. موافق؟",
            NEXT_CONFIRMATION_WITHOUT_PAYMENT: "سيتم إرسال بيانات الطلب فى الخطوه القادمه لذا يرجى مراجعة بيانات الطلب أولاً. موافق؟"
            ,FACULTY_CHOOSEN:"تم اختيار الكليه من قبل "
            ,ALL_FACULTY_CHOSEN:"تم اختيار جميع الكليات المتاحه للتقديم من قبل "

        },
        STEP4: {
            NAME: "الدفع وإرسال الطلب",
            EXPIRYPERIOD: "صالح لمدة",
            TABLETITLE: "بيانات الدفع",
            PERIOD: "ثلاث أيام",
            PAID: "مدفوع",
            REFERENCENUM: "الرقم المرجعي",
            RECEIPTNUM: "رقم الإيصال",
            PAIDDATE: "تاريخ الدفع",
            // TITLE:
            //   "لكي تتمكن من إرسال طلب التقدم يرجى سداد رسوم الطلب إلكترونياً عن طريق خدمة فوري أو بنك مصر كما يرجى التأكد من مراجعة بيانات الطلب وذلك لأن بإكمال عملية الدفع يتم إرسال الطلب",
            // TITLE: "لكي يتم النظر في طلب التقدم الخاص بك يرجى سداد رسوم الطلب إلكترونياً عن طريق خدمة فوري  ولمعرفته يتوجب عليك الذهاب للجامعة لأخذه كما يرجى التأكد من مراجعة بيانات الطلب وذلك لأن بإكمال عملية الدفع يتم النظر في الطلب",
            LINE1: "لكي يتم النظر في طلب التقدم الخاص بك يرجى سداد رسوم الطلب ",
            PAYMENT_PRICE: "1500",
            LINE1CONT: "جنية مصري عن طريق خدمة فوري ويمكنك معرفة كود السداد من خلال الضغط على الرابط التالي",
            LINE2: "كما يرجى التأكد من:",
            LINE3: "1 - مراجعة بيانات الطلب المقدم والمستندات المرفوعة ان تكون صحيحة وواضحة.",
            LINE4: "2 - سداد رسوم الطلب لأنه بدون عملية السداد لن يتم النظر في الطلب المقدم.",
            LINE5: "ملاحظة:",
            LINE6: "1. صلاحية كود السداد هي 5 ساعات من توقيت ظهور كود طلب السداد.",
            LINE7: "2. في حالة استخراج كود سداد ولم يتم الدفع خلال 5 ساعات من توقيت تقديم الطلب تستطيع اعادة طلب كود سداد للدفع مرة أخرى من خلال الرابط الذي يظهر أمامك وسيتم انشاء كود جديد حتى تتمكن من الدفع من خلاله.",
            //أو بنك مصر أو السداد على الحساب الخاص بالجامعة
            TAXS: "بالإضافة إلى عمولة الدفع",
            TECHNICAL_SUPPORT: "في حالة حدوث مشكلة ، يرجى الاتصال بالأرقام التالية : 16541",
            ONLINE_PAYMENT: "للدفع إلكترونياً",
            BANK_PAYMENT: "لإرسال الطلب  ",
            CLICK_HERE: "اضغط هنا",
            LE: "جنيه",
            HAS_REFRENCE_NOT_PAID: "طلبك # {paymentNum} معلق صالح لمدة 5 ساعات  فقط من تاريخ أخذ الرقم المرجعي {paymentDate} يمكنك دفع الرسوم من أي ماكينة دفع فوري أو من خلال (فيزا/بنك مصر) للدفع من خلالهم",
            HAS_REFRENCE_PAID: "طلبك # {paymentNum} تم دفعه بنجاح",
            EXPIRED: "طلبك # {paymentNum} أصبح منتهي",
            NOTE: "ملاحظة:",
            NOTE1: "1- في حالة استخراج رقم مرجعي ولم يتم الدفع خلال 5 ساعات تستطيع إعادة طلب رقم مرجعي للدفع مرة أخرى من خلال الرابط الذي يظهر أمامك و سيتم إنشاء رقم أخر حتى تتمكن من الدفع عليه",
            NOTE2: "2- في حالة اختيار إرسال الطلب والدفع عن طريق البنك لاحقا لن ينظر في طلب التقدم إلا في حالة اتمام عملية الدفع"
        }
    },
    UserData: {
        PROFILE: "الملف الشخصي",
        PROFILE_EDIT: "تعديل الملف الشخصي",
        PERSONAL_DATA: "البيانات الشخصية",
        CONTACT: "بيانات التواصل",
        CERTIFICATE: "بيانات المؤهل",
        APPLICATION: "بيانات كافة الرغبات ",
        FACULTY: "الكلية",
        APPLICATION_ID: "رقم الطلب",
        APPLICATION_STATUS: "حالة الطلب",
        DESIRE_NUMBER: "رقم الرغبة",
        AVATAR: "الصورة الشخصية",
        AR_NAME: "الإسم بالعربية",
        EN_NAME: "الإسم بالإنجليزية",
        NATIONALITY: "بلد الجنسية",
        NATIONAL_ID: "الرقم القومي",
        PASSPORT: "جواز السفر",
        GENDER: "النوع",
        MALE: "ذكر",
        FEMALE: "أنثى",
        BIRTHDAY: "تاريخ الميلاد",
        PHONE: "رقم التليفون",
        MOBILE: "رقم الموبايل",
        ADDRESS: "العنوان",
        BIRTHPLACE: "محل الميلاد",
        COUNTRY: "الدولة",
        STATE: "المحافظة / الولاية",
        CITY: "المدينة",
        EMAIL: "البريد الإلكتروني",
        CERTIFICATE_TYPE: "نوع الشهادة",
        CERTIFICATE_DEPT: "الشعبة",
        CERTIFICATE_YEAR: "عام الحصول عليها",
        CERTIFICATE_RESULT: "المجموع الكلي / الإعتبارى",
        CERTIFICATE_PERC: "النسبه",
        CERTIFICATE_RESULT_MAX: "المجموع الكلي / الإعتبارى يجب أن لا يزيد عن 9999",
        CERTIFICATE_Egy_MAX: "المجموع الكلي / الإعتبارى يجب أن لا يزيد عن 410",
        CERTIFICATE_PERC_MAX: "النسبه يجب أن لا تزيد عن 100",
        CERTIFICATE_EQ_TYPE: "نوع الشهاده المعادلة",
        CERTIFICATE_OTHER: "إسم الشهادة الأجنبية",
        CERTIFICATE_FOREIGN_TYPE: "إسم الشهادة الأجنبية",
        CERTIFICATE_EGYPTIAN_TYPE: "إسم الشهادة المصريه ",
        CANCEL_CONFIRMATION: "هل تريد العودة لصفحة الملف الشخصي؟",
        PIC_DELETE_CONFIRMATION: "هل تريد حذف وإستبدال الصورة؟",
        SAVE_CONFIRMATION:
            "هل تريد حفظ وإستبدال بيانات الملف الشخصي، بالبيانات المدخلة؟",
        CHANGE_PASSWORD: "تغيير كلمة المرور",
        NEW_PASSWORD: "كلمة المرور الجديدة",
        CONFIRM_NEW_PASSWORD: "تأكيد كلمة المرور الجديدة",

    },
    APPLICATION_TITLE: "طلب إلتحاق العام الاكاديمي {appYear} الفصل {appSemeter}",
    ALPHA_NUMERIC_FIELD: "يجب أن يحتوي هذا الحقل على حروف وأرقام فقط",
    COMPLETE_DATA_ERROR: "من فضلك قم بإكمال البيانات بشكل صحيح لإتمام الحفظ",
    NUMBER_FIELD: "يجب أن يحتوى هذا الحقل على أرقام فقط",
    UNSIGNED_FLOAT_NUMBER_FIELD: "يجب أن يحتوى هذا الحقل على أرقام موجبة فقط",
    IMAGE_SIZE_VALIDATION: "يجب أن لا يزيد حجم الصورة عن 5 ميجابايت",
    IMAGE_EXTENTION_VALIDATION: "يجب أن يحتوي هذا الحقل على صورة بإمتدادات أخرى",
    PDF_EXTENTION_VALIDATION: "يرجى رفع مرفق pdf",
    UNIVERSITY: "جامعة",
    INSTRUCTIONS: "إرشادات عامة",
    HOME: "الصفحة الرئيسية",
    NEW_APPLICATION: "تقديم طلب جديد",
    APPLICATIONS: "عرض الطلبات",
    REORDER_APPLICATIONS: "اعادة ترتيب الرغبات",
    DESIRE_NUMBER: "رقم الرغبة ",
    ARRANGE_DESIRES: "رتب رغباتك ",
    DESIRE_ORDER: "ترتيب الرغبة",
    YOU_HAVE_UNSAVED_DESIRES: "لم يتم إعادة حفظ ترتيب الرغبات  بعد ! هل ترغب فى طباعةاخر ترتيب للرغبات تم حفظه؟",
    SAVE_ORDER: "حفظ الترتيب",
    DESIRE_MESSAGE: " لا يمكنك اعادة ترتيب رغباتك فى الوقت الحالى",
    DESIRE_CONFIRMATION: "هل انت متاكد من اعادة ترتيب الرغبات بالشكل الحالى قبل الحفظ",
    PRINT_DATE: "تاريخ الطباعة",
    INTERNAL_MAIL: "البريد الداخلي",
    SUGGESTIONS: "أسئلة و مقترحات",
    SERIAL: "م",
    FACULTY: "الكلية",

    APPLICATION_DATE: "تاريخ التقدم",
    DRAFT_APPLY: "مسودة(معلق لحين إستكمال الارسال)",
    INITIAL_DRAFT_APPLY: "مسودة(تقديم مبدئي)",
    UNDER_REVIEW: "تحت المراجعة",
    INITIAL_UNDER_REVIEW: "تحت المراجعة(تقديم مبدئي)",
    ACCEPTED: "مقبول",
    REJECTED: "مرفوض",
    TO_BE_COMP: "مطلوب إكماله",
    ACKNOWLEDGMENT: "إقرار",
    IMPORTANT_NOTES: "ملاحظات هامة",
    IMPORTANT_NOTES_TEXT:
        " هذه البطاقة مجرد اخطار للطالب بالكلية المتقدم لها ولا تعتبر مستنداً" +
        " لقيد الطالب بها ",
    NO_NOTIFICATIONS: "لا توجد إشعارات حالياً",
    MOBILE_VALIDATION: "أدخل رقم الموبايل بشكل صحيح",
    SEND_NEW_PASSWORD: "إرسال كلمة مرور جديدة",
    SEND_ACTIVATION_CODE: "إرسال بريد لتفعيل الحساب ",
    NATIONALITY_REQUIRED: "مطلوب إدخال الجنسية",
    END_APP_DATE: "انتهت فترة التقديم",
    FUTURE_DATE: "يجب إدخال تاريخ يسبق تاريخ اليوم",
    FUTURE_DATE_RANGE: "السن يجب أن يكون  من 14 سنة إلى  31",
    VALID_DATE_RANGE: "السن يجب أن لا يكون أصغر من 14 سنة، أو أكبر من 31 سنة",
    CONFIRM_CANCEL: "هل تريد الإلغاء و العودة؟",
    CONFIRM_RESET_PASSWORD: "تم تغيير كلمة المرور الخاصه بك يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديده ",
    ACCEPT_CANDIDATE: "مرشح للقبول",
    REJECT_CANDIDATE: "مرشح للرفض",
    SEND_NO_FEES: "تحت المراجعه",
    TRANSFERRED: "تم النقل الى شؤون طلاب",
    REFUSED_AS_OTHER_ACCEPTED: "مقبول بكليه اخرى",
    WAITING: "قيد الإنتظار",
    PRINT_NOMINATION_CARD: "طباعة بطاقة الترشيح",
};
export default translationsAr;
